/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popOpenEvent.vue?vue&type=template&id=21d15b4b&scoped=true"
import script from "./popOpenEvent.vue?vue&type=script&lang=js"
export * from "./popOpenEvent.vue?vue&type=script&lang=js"
import style0 from "./popOpenEvent.vue?vue&type=style&index=0&id=21d15b4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d15b4b",
  null
  
)

export default component.exports